//=============================================================================
// UHS we use this file
// This file contains the javascript for our custom product block
// created to be able to show 2 rows of products on mobile and decrease
// the number of generated elements on the page
//=============================================================================

$(document).ready(function() {

  //Global variables to handle mouse and touch events
  let prevent_default = false;
  let mouse_down = false;
  let mouse_start_position;
  let mouse_current_position;
  let slide_start_position;
  let slide_current_position;
  let slide_moved = false;
  let product_card_width = ($('.custom-product-card').width() * 0.5);
  let all_sliders = $('.custom-carousel__container');
  

  //Initializing
  arrowsShowHide();
  dotsAdd();
  dotsAssignActive(all_sliders);
  
  
  //Resets variables on page resize
  $(window).on('resize', function() {
    product_card_width = ($('.custom-product-card').width() * 0.5);
    arrowsShowHide();
    dotsAdd();
    dotsAssignActive(all_sliders);
  });
  

  $(document).on('click', '.custom-carousel__previous, .custom-carousel__next', function() {
    arrowsClick(event);
  });

  
  $(document).on('click', '.custom-carousel__dot', function() {
    dotsClick(event);
  });

  
  //Prevents unwanted link clicks while scrolling the sliders
  $(document).on('click', '.custom-carousel__main', function() {
    temporaryPreventDefault(prevent_default);
  });


  //Handles mousedown and touchstart events this is the first step in the drag functionality
  //Sets the start position of the slide and mouse to be used later
  $(document).on('mousedown touchstart', '.custom-carousel__main', function(event) {
    if(event.type === 'touchstart') {
      mouse_start_position = event.originalEvent.touches[0].pageX;
    } else {
      mouse_start_position = event.pageX || event.clientX;
      event.preventDefault();
    }
  
    mouse_down = true;
    slide_moved = false;
    slide_start_position = $(event.target).closest('.custom-carousel__main').scrollLeft();
  });
  

  //While holding down the mouse or touch this event begins to fire
  //Sets prevent_default to prevent unwanted link clicks while dragging
  //If not dragged then does not disable thus allowing links to be clicked
  //Contains part of the animation for the slide to move
  $(document).on('mousemove touchmove', '.custom-carousel__main', function(event) {
    if(mouse_down) {
      let closest_container = $(event.target).closest('.custom-carousel__main');
      
      if (event.type === 'touchmove') {
        mouse_current_position = mouse_start_position - event.originalEvent.touches[0].pageX;
      } else {
        mouse_current_position = mouse_start_position - (event.pageX || event.clientX);
      }
  
      slide_current_position = slide_start_position + mouse_current_position;
      prevent_default = true;
  
      closest_container.scrollLeft(slide_current_position)
    } else {
      prevent_default = false;
    }
  });
  

  //Last step determines if the slide was moved or not
  //If it was it will animate the slide to the desired position
  //Otherwise slides back to original position
  $(document).on('mouseup touchend', '.custom-carousel__main', function(event) {
    if (!slide_moved) {
      mouse_down = false;
      let closest_container = $(event.target).closest('.custom-carousel__container');
      let container_width = $(closest_container).width();
      let carousel_slide = $(event.target).closest('.custom-carousel__main');
  
      if(Math.abs(mouse_current_position) > product_card_width) {
        if (mouse_current_position >= 0) {
          carousel_slide.animate({ scrollLeft: slide_start_position + container_width }, 300, function() { dotsAssignActive(closest_container); });
        } else {
          carousel_slide.animate({ scrollLeft: slide_start_position - container_width }, 300, function() { dotsAssignActive(closest_container); });
        }
      } else {
        carousel_slide.animate({ scrollLeft: slide_start_position }, 300, function() { dotsAssignActive(closest_container); });
      }
  
      slide_moved = true;
      mouse_current_position = 0;
    }
  });
  
  //does the same as above but acts as a catchall in case the users mouse leaves the element
  //only fires if slide_move was not resolved by 'mouseup touchend' event
  $(document).on('mouseleave', '.custom-carousel__main', function(event) {
    if(!slide_moved) {
      event.preventDefault();
      mouse_down = false;
      let closest_container = $(event.target).closest('.custom-carousel__container');
      let container_width = $(closest_container).width();
      let carousel_slide = $(event.target).closest('.custom-carousel__main');
  
      if (Math.abs(mouse_current_position) > product_card_width) {
        if (mouse_current_position >= 0) {
          carousel_slide.animate({ scrollLeft: slide_start_position + container_width }, 300, function() { dotsAssignActive(closest_container); });
        } else {
          carousel_slide.animate({ scrollLeft: slide_start_position - container_width }, 300, function() { dotsAssignActive(closest_container); });
        }
      } else {
        carousel_slide.animate({ scrollLeft: slide_start_position }, 300, function() { dotsAssignActive(closest_container); });
      }
  
      slide_moved = true;
      mouse_current_position = 0;
    }
  });

});

//Function to handle what happens when arrow buttons are clicked
function arrowsClick(event) {
  let navigation_button = $(event.target).closest('[class*="custom-carousel__"]');
  let closest_container = $(event.target).closest('.custom-carousel__container');
  let clicked_element = closest_container.find('.custom-carousel__main');
  let current_scroll = clicked_element.scrollLeft();
  let padding = parseFloat($('.custom-carousel__container').css('padding-left')) + parseFloat($('.custom-carousel__container').css('padding-right'));
  let container_width = closest_container.width();

  if (navigation_button.hasClass('custom-carousel__next')) {
    clicked_element.animate({ scrollLeft: current_scroll + container_width }, 300, function() { dotsAssignActive(closest_container); });
  } else if (navigation_button.hasClass('custom-carousel__previous')) {
    clicked_element.animate({ scrollLeft: current_scroll - container_width }, 300, function() { dotsAssignActive(closest_container); });
  }
  console.log('click arrow: ' + container_width);
}

//Hides buttons if carousel contains less than 4 or 6 products
function arrowsShowHide() {
  let sliders = $('.custom-carousel__container');

  sliders.each(function() {
    let products = $(this).find('.custom-product-card');
    let buttons = $(this).find('.custom-carousel__previous, .custom-carousel__next');
    let products_per_slide = $(this).data('products-per-slide');

    if(window.innerWidth > 1450) {
      if(products.length <= products_per_slide) {
        buttons.hide();
      } else {
        buttons.show();
      }
    } else {
      if(products.length <= 4) {
        buttons.hide();
      } else {
        buttons.show();
      }
    }
  });
}

//Adds navigation dots according to how many pages the slider has
function dotsAdd() {
  let sliders = $('.custom-carousel__container');

  sliders.each(function() {
    let products = $(this).find('.custom-product-card');
    let dots_container = $(this).find('.custom-carousel__dots');
    let products_per_slide = $(this).data('products-per-slide');

    if(window.innerWidth > 1450) {
      $(dots_container).empty();
      if(products.length > products_per_slide) {
        for(let i = 0; i < (products.length / products_per_slide); i++) {
          $(dots_container).append('<button class="custom-carousel__dot" data-dot-position="' + i + '" aria-label="dot-slide-'  + i +  '">&nbsp;</button>');
        }
      }
    } else {
      if(products.length > 4) {
        $(dots_container).empty();
        for(let i = 0; i < (products.length / 4); i++) {
          $(dots_container).append('<button class="custom-carousel__dot" data-dot-position="' + i + '" aria-label="dot-slide-'  + i +  '">&nbsp;</button>');
        }
      }
    }
    
  });
}

//Handles what happens when a navigation dot is clicked
function dotsClick(event) {
  let closest_container = $(event.target).closest('.custom-carousel__container');
  let container_width = closest_container.width();
  let carousel_element = closest_container.find('.custom-carousel__main');
  let dot_container = $(event.target).closest('.custom-carousel__dots');
  let clicked_dot = $(event.target);
  let clicked_dot_position = $(clicked_dot).data('dot-position');

  carousel_element.animate({ scrollLeft: (container_width * clicked_dot_position)  }, 300, function() { dotsAssignActive(closest_container); });
}

//Assigns the active class to the dot that is active
function dotsAssignActive(element_object) {
  
  element_object.each(function() {
    let carousel_element = $(this).find('.custom-carousel__main');
    let carousel_width = carousel_element.width();
    let current_scroll = carousel_element.scrollLeft();
    let active_dot = Math.ceil(current_scroll / carousel_width);
    
    $(this).find('.custom-carousel__dot--active').removeClass('custom-carousel__dot--active');
    $(this).find('[data-dot-position="' + active_dot + '"]').addClass('custom-carousel__dot--active');
  });
}

//Function to temporarily disable events
function temporaryPreventDefault(prevent_default) {
  if(prevent_default) {
      event.preventDefault();
    }
    prevent_default = false;
}























